export const widgetKinds = Object.freeze({
  BOOLEAN_RADIOS: "BOOLEAN_RADIOS",
  TREE: "TREE",
  CHECKBOX: "CHECKBOX",
  TAGS: "TAGS",
  AGE_RADIOS: "AGE_RADIOS",
  DATE_PICKER: "DATE_PICKER",
  DATE_RADIOS: "DATE_RADIOS",
  TEXT_INPUT: "TEXT_INPUT",
} as const);

export type WidgetKind = (typeof widgetKinds)[keyof typeof widgetKinds];
